module.exports = __webpack_public_path__ + "static/media/dieter_mrochen_v2.509c384b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/dieter_mrochen_v2.jpg
// module id = 433
// module chunks = 0